export function mapUserProfile(data) {
  return {
    id: data.id,
    name: data.name,
    email: data.email,
    hp: data.hp,
    balance: data.balance,
    address: data.address,
    avatar: data.avatar || null,
  }
}
